module.exports = __webpack_public_path__ + "static/media/winemaker_opi.88055a14.png";